var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6777 19C12.5407 19.0005 12.4054 18.9676 12.2817 18.9035C12.158 18.8395 12.049 18.7461 11.9627 18.63L7.53519 12.63C7.40037 12.4511 7.32666 12.2267 7.32666 11.995C7.32666 11.7634 7.40037 11.539 7.53519 11.36L12.1185 5.36003C12.2741 5.15581 12.4977 5.02739 12.7401 5.00301C12.9825 4.97863 13.2238 5.06029 13.411 5.23003C13.5982 5.39977 13.7159 5.64368 13.7383 5.90811C13.7606 6.17253 13.6858 6.43581 13.5302 6.64003L9.43269 12L13.3927 17.36C13.5048 17.5068 13.576 17.6856 13.5979 17.8751C13.6198 18.0647 13.5914 18.2571 13.5162 18.4296C13.441 18.6021 13.322 18.7475 13.1734 18.8486C13.0248 18.9497 12.8528 19.0023 12.6777 19Z",
    fill: "#056E9C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a0acc267765bde24742edf650bc2bdaf.svg";
export { ForwardRef as ReactComponent };